/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Ajuste visual de total en letra
* --------------------------------------------------------------------------------------- 
*/

import React, { useEffect, useState } from 'react';
import {NumberFormat$} from "../../settings/utils";

const getVentasTotales = () => ({
  subTotal: 0,
  totalDescuento:0,
  totalIVA:0,
  total:0,
  montoEnLetra:""
});

const SizeSoftXDetallesVentas = ({ ventasTotales = []}) => {

  const [totales , setTotales] = useState(getVentasTotales());

  useEffect(() => {
    if (ventasTotales.total != 0)  
    {
      setTotales(ventasTotales);
    }
    else
    {
      setTotales(getVentasTotales());
    }
  },[ventasTotales])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <div>
        <input 
          className="textboxdetalles" 
          type="text" 
          value={"Desc: " + NumberFormat$(totales.totalDescuento)} 
          readOnly 
          style={{ textAlign: 'left' }}
        />
      </div>
      <div>
        <input 
          className="textboxdetalles" 
          type="text" 
          value={"Subt: " + NumberFormat$(totales.subTotal)} 
          readOnly 
          style={{ textAlign: 'left' }}
        />
      </div>
      <div>
        <input 
          className="textboxdetalles" 
          type="text" 
          value={"IVA: " + NumberFormat$(totales.totalIVA)} 
          readOnly 
          style={{ textAlign: 'left' }}
        />
      </div>
      <div>
        <input 
          className="textboxdetallesTotal" 
          type="text" 
          value={NumberFormat$(totales.total)} 
          readOnly 
          style={{ textAlign: 'left', fontWeight: 'bold' }}
        />
      </div>      
      <div>
        <textarea 
          className="textboxdetalles textboxdetallesTotalLetra" 
          rows="5" 
          value={totales.montoEnLetra} 
          readOnly 
          placeholder="Total en letra"
        />
      </div>      
    </div>
  );
};

export default SizeSoftXDetallesVentas;
